import { Link, useNavigate } from "react-router-dom";
import {
  WEBSITE_DATA,
  CURRENT_DOMAIN,
  TYPES,
  PRODUCT_TYPE_CAPS,
} from "../../constants/dashboard";
import BackArrow from "../../assets/backArrow.svg";
import ForwardArrow from "../../assets/ForwardArrow.svg";
//import Play from "../../assets/PlayIcon.svg";
import { useState } from "react";
import "./style.css";

const TAS = () => {
  const [selectedClass, setSelectedClass] = useState(2);
  const tasData = WEBSITE_DATA?.innderComponents[1]?.domains?.includes(
    CURRENT_DOMAIN
  )
    ? WEBSITE_DATA.innderComponents[1]?.components[0]
    : [];
  const component = tasData?.componentCP.filter((a) =>
    a?.domains?.includes(CURRENT_DOMAIN)
  );
  const [currentSubjectList, setCurrentSubjectList] = useState(
    component[0].dataList[0]
  );
  const navigate = useNavigate();

  const changeClass = (id) => {
    setSelectedClass(id);
    let res = component[0].dataList.filter((a) => a.id === id);
    setCurrentSubjectList(res[0]);
  };

  const onClickNavigate = (subject, chapter, day, component, label) => {
    navigate(`/lp`, { state: { component, subject, chapter, day, label } });
  };

  const getComponent = (dataList) => {
    const filteredData = dataList.filter((a) =>
      a?.domains?.includes(CURRENT_DOMAIN)
    );

    return filteredData.map((z, idx) => (
      <div className="images" key={idx}>
        <Link to={z?.link} className="image-container">
          <img className="thumbnail" src={z.img} alt="" />
          {/* <img
            src={Play}
            alt="play"
            className={filteredData.length > 1 ? "play" : "singlePlay"}
          /> */}
          <p className="duration">{z?.timeTakenToComplete}</p>
        </Link>
        {CURRENT_DOMAIN === PRODUCT_TYPE_CAPS.PINNACLE && (
          <p className="label">{z?.heading}</p>
        )}
      </div>
    ));
  };

  //console.log(currentSubjectList);

  return (
    <>
      <div className="head">
        <img
          src={BackArrow}
          className="back"
          alt="back"
          onClick={() => navigate("/")}
        />
        <img id="img" src={WEBSITE_DATA?.logo} alt="title" />
      </div>

      <div className="data">
        <h2 className="heading1">
          {/* <span className="head1">{tasData?.headingPart1}</span>{" "} */}
          <span className="head2">{tasData?.headingPart2}</span>
        </h2>
        <p className="subhead">{tasData?.subHeading}</p>
        {tasData?.componentCP
          .filter((a) => a?.domains?.includes(CURRENT_DOMAIN))
          .map((b, idx) => (
            <span key={idx}>
              {b?.type === TYPES.CARD_LESSON_PLANS && (
                <div className="lesson-plan" key={b?.heading}>
                  <h2>{b?.heading}</h2>
                  <p>{b?.subHeading}</p>
                  <div className="classes">
                    {b?.dataList?.map((i) => (
                      <div
                        key={i.label}
                        onClick={() => changeClass(i.id)}
                        className={`class ${
                          selectedClass === i.id ? "active" : ""
                        }`}
                      >
                        {i.label}
                      </div>
                    ))}
                  </div>

                  <div className="days">
                    {currentSubjectList.subjects.map((s, idx) => (
                      <div
                        key={idx}
                        className={`subjects ${s.className}`}
                        style={{ border: `1px solid ${s.colorCode}` }}
                      >
                        <div
                          className="subject"
                          style={{ backgroundColor: s.colorCode }}
                        >
                          {s.label.length > 7
                            ? s.label.slice(0, 7) + "..."
                            : s.label}
                        </div>
                        <div className="day-plans">
                          {s.dayPlans.map((z, idx) => (
                            <div
                              key={idx}
                              className="plan"
                              role="presentation"
                              onClick={() =>
                                onClickNavigate(
                                  s.label,
                                  z.chapter,
                                  z.day,
                                  z.component,
                                  currentSubjectList.label
                                )
                              }
                            >
                              <p>{z.label}</p>
                              <img src={ForwardArrow} alt="forward" />
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {b?.type === TYPES.CARD_MEDIA_VIDEO && (
                <div className="video" key={b?.heading}>
                  <h2>{b?.heading}</h2>
                  <p>{b?.subHeading}</p>
                  <div className="files">{getComponent(b.dataList)}</div>
                </div>
              )}
            </span>
          ))}
        <div className="explore">
          <h1 className="heading">
            {tasData?.componentCP[tasData?.componentCP?.length - 1].heading}
          </h1>
          <div className="card-links">
            {tasData?.componentCP[tasData?.componentCP?.length - 1].dataList
              .filter((a) => a?.domains?.includes(CURRENT_DOMAIN))
              .map((b, idx) => (
                <div key={idx} className="images">
                  {b?.type === TYPES.CARD_LINK && (
                    <Link to={b?.link}>
                      <img src={b?.img} alt="sa-img" className="image" />
                    </Link>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TAS;
